export function addCurrent(calledflow) {
    return {
        type: 'ADD_CURRENT',
        calledflow,
    }
}
